export const CHINA_COUNTRY_CODE = "cn";
export const JAPAN_COUNTRY_CODE = "jp";
export const KOREA_COUNTRY_CODE = "kr";
export const CANADA_COUNTRY_CODE = "ca";
export const US_COUNTRY_CODE = "us";
export const NEW_ZEALAND_CODE = "nz";
export const AUSTRALIA_CODE = "au";
export const GERMANY_CODE = "de";
export const INDIA_CODE = "in";
export const UK_CODE = "uk";

// ALERT ACTIONS START //
export const ERROR_ALERT = "ERROR_ALERT";
export const SUCCESS_ALERT = "SUCCESS_ALERT";
export const FIND_FEDERATED = "FIND_FEDERATED";
export const FIND_RP_URLS = "FIND_RP_URLS";
export const SEND_UPDATED_NOTIFICATION = "SEND_UPDATED_NOTIFICATION";
export const WE_CHAT_MAIL_CHECK = 'WE_CHAT_MAIL_CHECK';
export const WE_CHAT_PASSWORD_CHECK = 'WE_CHAT_PASSWORD_CHECK';

// ALERT ACTIONS END //
